import type { Router, RouteLocationNormalizedLoaded } from 'vue-router'

import {
  buildCreateV2FromMapQuery,
  clickCoordsToLngLat,
  normalizeMapDrawCoordinates,
  resolveMapRouteParams,
} from '@/features/Inventory/CreatePassportV2Batch/model/mapEntryQuery.ts'

export type NavigateToCreateV2FromMapInput = {
  inventTypeId: number
  parentId: number
  coordinates: unknown
  zoom: number
}

/**
 * Navigate from inventory map add-mode click to Create V2 batch with fixed coordinates.
 */
export function navigateToCreateV2FromMap(
  router: Router,
  route: RouteLocationNormalizedLoaded,
  input: NavigateToCreateV2FromMapInput,
): boolean {
  const geometry = normalizeMapDrawCoordinates(input.coordinates)
  const loc = clickCoordsToLngLat(geometry ?? input.coordinates)
  if (!loc) return false

  const { type, objectId } = resolveMapRouteParams(route.params)
  const groupObjectId = Number(objectId)
  if (!objectId || !Number.isFinite(groupObjectId) || groupObjectId <= 0) return false

  const parentId =
    Number.isFinite(input.parentId) && input.parentId > 0 ? input.parentId : groupObjectId

  router.push({
    name: 'object.inventory.type.elements.create-v2',
    params: {
      type,
      object_id: objectId,
      tab: 'inventory',
      invent_type_id: String(input.inventTypeId),
      tab_inventory: 'elements',
    },
    query: buildCreateV2FromMapQuery({
      lng: loc.lng,
      lat: loc.lat,
      zoom: input.zoom,
      parentId,
      groupObjectId,
      returnMapType: type,
      geometry: geometry ?? undefined,
    }),
  })

  return true
}
